(function () {
  angular.module('app.eligibility-report-modal', ['app.print-content'])
        .directive('dcEligibilityReportModal', () => {
          return {
            template: require('./eligibility-report.pug')(),
            restrict: 'E',
            scope: {
              reportHtmlContent: '=',
              patientName: '@',
              showReportModal: '='
            },
            controller: eligibilityReportModalCtrl,
            controllerAs: 'vm',
            bindToController: true
          };
        });

  eligibilityReportModalCtrl.$inject = ['$sce'];

  function eligibilityReportModalCtrl($sce) {
    var vm = this;
    vm.getReportContent = getReportContent;

    function getReportContent() {
      return $sce.trustAsHtml(vm.reportHtmlContent);
    }
  }
})();
